<script setup>
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    default: '',
  },
})
const emit = defineEmits(['update:modelValue'])

const selectMode = (value) => {
  if (value !== props.modelValue) {
    emit('update:modelValue', value)
  }
}
</script>

<template>
  <div role="radiogroup" class="mode-toggle">
    <button
      v-for="option in props.options"
      :key="option.value"
      type="button"
      class="mode-toggle__item"
      :class="{ 'is-active': props.modelValue === option.value }"
      @click="selectMode(option.value)"
    >
      <span :class="['mode-toggle__decor', option.value]"></span>
      <span>{{ option.label }}</span>
    </button>
  </div>
</template>

<style scoped>
.mode-toggle {
  display: inline-flex;
  padding: 0.4rem;
  background: var(--semantic-bg-petrol-subtle);
  border-radius: 999px;
  gap: var(--space-8);
  border: 1px solid var(--color-grey-mid);
  width: fit-content;
  margin: 0 auto;
}

.mode-toggle__item {
  border: 1px solid transparent;
  background: transparent;
  padding: 0.35rem 1.4rem;
  border-radius: 999px;
  color: var(--semantic-text-default);
  font-weight: 600;
  font-size: 1.125rem;
  display: inline-flex;
  align-items: center;
  gap: var(--space-8);
  cursor: pointer;
}

.mode-toggle__decor {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  filter: grayscale(1);
}

.mode-toggle__item.is-active {
  background: var(--semantic-bg-default);
  border: 1px solid var(--color-grey-mid);
  color: var(--semantic-text-default);
}

.mode-toggle__item.is-active .heating {
  filter: none;
}
.mode-toggle__item.is-active .cooling {
  filter: none;
}
</style>
